<template>
  <p class="selected_list margin-top" v-if="persons.length">
    <span v-for="(item, index) in persons" :key="index">
      {{ item.staff_name }}
      <img src="@/assets/img/add-close1.png" @click="$emit('remove', index)" />
    </span>
    <!-- 清除 -->
    <a @click="$emit('empty')">{{ $t('747') }}</a>
  </p>
</template>

<script>
export default {
  props: {
    // 已选列表
    persons: {
      default: () => [],
      type: Array
    }
  }
}
</script>
